module.exports = __webpack_public_path__ + "fepro/img/card-box-bg-3.ed11f598.png";